import React, { useEffect } from 'react'
import CustomDateTime from 'designer/component/element/DateTime'
import { copyDataByCondition } from 'designer/component/action/Condition'
import { isEmpty } from 'designer/component/action/condition/State'
import { getStorage } from 'designer/component/action/Storage'
import { getDateTimeFormValue } from 'designer/component/action/Date'

import PropWrapper from './PropWrapper'
import {
  updateFieldValue,
  updateMapResponse,
  updateOnChange,
  updateWidgetData,
} from './DataControl'
import { INVALID_DATE_TIME_VALUE } from 'designer/component/validation/dateTime'

const Children = ({ dataProps }) => {
  const {
    props,
    designContext,
    fieldProps,
    fieldName,
    fieldKey,
    errors,
    setIsOnChange,
  } = dataProps
  const { jsonForm, setFormData, isResetData, elementAction } = designContext
  const { uischema } = props
  let { defaultType, label } = uischema
  const formData = jsonForm.formData || {}
  const { uiKey, uiName, value, defaultValue, renderWidget, mapResponse } =
    fieldProps

  const updateData = (dateTime, isOnChange) => {
    let value =
      dateTime?.value === INVALID_DATE_TIME_VALUE
        ? INVALID_DATE_TIME_VALUE
        : getDateTimeFormValue(dateTime, uischema?.timestamp)
    updateValue(value, isOnChange)
  }

  const updateValue = (value, isOnChange) => {
    updateFieldValue({ ...dataProps, value, isOnChange })
  }

  const copyData = (dateTime) => {
    let value = getDateTimeFormValue(dateTime, uischema?.timestamp)
    let newFormData = copyDataByCondition(value, elementAction, uiKey, formData)
    setFormData(newFormData)
  }

  useEffect(() => {
    updateOnChange({ ...dataProps, value })
  }, [value])

  useEffect(() => {
    if (isEmpty(value) || isResetData) {
      let currentDate = defaultValue
      if (defaultType === 'current') {
        currentDate = getDateTimeFormValue(new Date(), uischema?.timestamp)
      }
      let storage = getStorage(jsonForm, uiName)
      let value
      if (isEmpty(storage)) {
        value = currentDate
      } else {
        value = storage
      }
      updateValue(value)
    }
  }, [defaultValue, defaultType, isResetData, uischema?.timestamp])

  useEffect(() => {
    updateMapResponse(dataProps)
  }, [mapResponse])

  useEffect(() => {
    updateWidgetData(dataProps)
  }, [renderWidget])

  return (
    <CustomDateTime
      fieldName={fieldName}
      fieldKey={fieldKey}
      label={label}
      uischema={uischema}
      value={value}
      updateData={updateData}
      copyData={copyData}
      errors={errors}
      uiKey={uiKey}
      setIsOnChange={setIsOnChange}
    />
  )
}

const DateTimeControl = (props) => {
  return (
    <PropWrapper {...props}>
      {({ dataProps }) => <Children dataProps={dataProps} />}
    </PropWrapper>
  )
}

export default DateTimeControl
